import { useMemo } from 'react';
import useStore from '@components/MainStage/store';
import { DomainItem } from '@constants/forms/scope-settings';
import useProjectId from '@hooks/useProjectId';
import { skipToken } from '@reduxjs/toolkit/query';
import { DomainNode } from '@store/services/nodes/types';
import { useGetProjectDomainsQuery } from '@store/services/projects';
import { parseDomains } from '@utils/helpers';

const useVirtualDomains = () => {
  const projectId = useProjectId();
  const { getActiveNode } = useStore();
  const activeNode = getActiveNode();

  const { data: projectDomains } = useGetProjectDomainsQuery(
    projectId || skipToken,
  );

  return useMemo(() => {
    if (!projectDomains) {
      return {
        inheritedDomains: [] as DomainItem[],
      };
    }

    const domainNodes = (activeNode?.data?.dto?.domainNodes ||
      []) as DomainNode[];

    return {
      inheritedDomains: parseDomains(
        projectDomains,
        (id) =>
          !domainNodes.some(
            ({ domain_id, type }) => domain_id === id && type === 'inherited',
          ),
      ),
    };
  }, [activeNode?.data?.dto?.id, projectDomains]);
};

export default useVirtualDomains;
